import { Entity } from '@backstage/catalog-model';
import { z } from 'zod';

export interface WitboostVersionedEntity extends Entity {
  spec: {
    mesh: {
      name: string;
      version: string;
    } & Record<string, any>;
  } & Record<string, any>;
}

export const WitboostVersionedEntitySchema = z
  .object({
    apiVersion: z.string(),
    kind: z.string(),
    metadata: z
      .object({
        name: z.string(),
      })
      .passthrough(),
    spec: z
      .object({
        mesh: z
          .object({
            name: z.string(),
            version: z.string(),
          })
          .passthrough(),
      })
      .passthrough(),
  })
  .passthrough();

export type WitboostVersionedEntityZod = z.infer<
  typeof WitboostVersionedEntitySchema
>;

export const validateWitboostVersionedEntity = (data: unknown) => {
  WitboostVersionedEntitySchema.parse(data);

  return data as WitboostVersionedEntity;
};
